module.exports = __webpack_public_path__ + "static/media/about-vision.976ec748.webp";